import React from 'react'

const CP_strRev = () => {
    return (
        <div className='container'>
            <h1>Reverse a string in C++</h1>
            <p>Given a string, write a C++ program to reverse it.</p>
            <div class="containers">
  <div class="line number1 index0 alt2"><code class="comment">// C++ program to print reverse of a string</code></div>
  <div class="line number2 index1 alt1"><code class="library">#include &lt;bits/stdc++.h&gt;</code></div>
  <div class="line number3 index2 alt2"><code class="keywords">using</code> <code
      class="keywords">namespace</code> <code class="plain">std;</code></div>
  <div class="line number4 index3 alt1">&nbsp;</div>
  <div class="line number5 index4 alt2"><code class="comment">// Function to reverse a string</code></div>
  <div class="line number6 index5 alt1"><code class="keywords">void</code> <code
      class="plain">reverse(string str)</code></div>
  <div class="line number7 index6 alt2"><code class="plain">&#123;</code></div>
  <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
      class="keywords">for</code> <code class="plain">(</code><code class="keywords">int</code> <code
      class="plain">i=str.length()-1; i&gt;=0; i--)</code></div>
  <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">cout &lt;&lt; str[i];</code></div>
  <div class="line number10 index9 alt1"><code class="plain">&#125;</code></div>
  <div class="line number11 index10 alt2">&nbsp;</div>
 
  <div class="line number13 index12 alt2"><code class="keywords">int</code> <code class="plain">main(</code><code
      class="keywords">void</code><code class="plain">)</code></div>
  <div class="line number14 index13 alt1"><code class="plain">&#123;</code></div>
  <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">string s = </code><code class="string">"NooBGeeks"</code><code class="plain">;</code></div>
  <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">reverse(s);</code></div>
  <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="keywords">return</code> <code class="plain">(0);</code></div>
  <div class="line number18 index17 alt1"><code class="plain">&#125;</code></div>
</div>
        </div>
    )
}

export default CP_strRev
